export default __webpack_public_path__ + "static/media/newLead10.2c3474bb.png";